import { z } from 'zod';

const stripCrlf = (s: string) => s.replace(/[\r\n]/g, ' ');

export const contactSchema = z.object({
  name: z
    .string()
    .trim()
    .min(2, 'Bitte geben Sie Ihren Namen an (mindestens 2 Zeichen).')
    .max(80, 'Der Name darf maximal 80 Zeichen lang sein.')
    .transform(stripCrlf),
  email: z
    .string()
    .trim()
    .max(120, 'Die E-Mail-Adresse ist zu lang.')
    .email('Bitte geben Sie eine gültige E-Mail-Adresse an.')
    .transform((s) => s.replace(/[\r\n]/g, '')),
  subject: z
    .string()
    .trim()
    .min(3, 'Bitte geben Sie einen Betreff an (mindestens 3 Zeichen).')
    .max(120, 'Der Betreff darf maximal 120 Zeichen lang sein.')
    .transform(stripCrlf),
  message: z
    .string()
    .trim()
    .min(10, 'Bitte beschreiben Sie Ihr Anliegen (mindestens 10 Zeichen).')
    .max(5000, 'Die Nachricht darf maximal 5000 Zeichen lang sein.'),
  consent: z
    .boolean()
    .refine((v) => v === true, {
      message: 'Bitte stimmen Sie der Datenschutzerklärung zu.',
    }),
});

export type ContactInput = z.infer<typeof contactSchema>;
